import React, { useState } from 'react';

function CollapsibleSection({ title, children, defaultOpen = false, onToggle }) {
  const [open, setOpen] = useState(defaultOpen);

  const handleToggle = () => {
    const next = !open;
    setOpen(next);
    onToggle?.(next);
  };

  return (
    <div className="border rounded mb-3 overflow-hidden bg-white">
      <button
        type="button"
        className="w-100 d-flex justify-content-between align-items-center p-3 bg-light border-0 fw-semibold text-start"
        onClick={handleToggle}
        aria-expanded={open}
      >
        <span>{title}</span>
        <span className="text-muted ms-2" aria-hidden="true">{open ? '▲' : '▼'}</span>
      </button>
      <div className={open ? 'p-3 border-top' : 'd-none'}>
        {children}
      </div>
    </div>
  );
}

export default CollapsibleSection;
